/**
 * Invitation context for Solid Start lives in the URL (not session storage) so
 * flow redirects can rebuild a working Verify link without persisting PII.
 *
 * Legacy links: uuid + veteranContactEmail
 * New links: uuid + data (base64-encoded GetVeteran email field key)
 */

/**
 * @param {{ uuid?: string | null, veteranContactEmail?: string | null, data?: string | null }} invitation
 * @returns {boolean}
 */
export function hasCompleteInvitation({
  uuid,
  veteranContactEmail,
  data,
} = {}) {
  return Boolean(uuid && (veteranContactEmail || data));
}

/**
 * @param {string} search - location.search (may include leading ?)
 * @returns {{ uuid: string | null, veteranContactEmail: string | null, data: string | null }}
 */
export function parseInvitationFromSearch(search) {
  if (!search || search === '?') {
    return { uuid: null, veteranContactEmail: null, data: null };
  }
  const normalized = search.startsWith('?') ? search.slice(1) : search;
  const p = new URLSearchParams(normalized);
  return {
    uuid: p.get('uuid'),
    veteranContactEmail: p.get('veteranContactEmail'),
    data: p.get('data'),
  };
}

/**
 * @param {{ uuid?: string | null, veteranContactEmail?: string | null, data?: string | null, cancel?: boolean }} params
 * @returns {string} '' or '?uuid=...' query string for router navigation
 */
export function buildInvitationSearch({
  uuid,
  veteranContactEmail,
  data,
  cancel,
} = {}) {
  const p = new URLSearchParams();
  if (uuid) {
    p.set('uuid', uuid);
  }
  if (veteranContactEmail) {
    p.set('veteranContactEmail', veteranContactEmail);
  }
  if (data) {
    p.set('data', data);
  }
  if (cancel) {
    p.set('cancel', 'true');
  }
  const s = p.toString();
  return s ? `?${s}` : '';
}

/**
 * @param {string} pathname
 * @param {string} search - location.search from react-router (includes ? when non-empty)
 * @returns {string}
 */
export function pathWithSearch(pathname, search) {
  if (!search || search === '?') {
    return pathname;
  }
  return `${pathname}${search}`;
}
